import { render, staticRenderFns } from "./jxqrczslb.vue?vue&type=template&id=7a2908a4&scoped=true&"
import script from "./jxqrczslb.vue?vue&type=script&lang=js&"
export * from "./jxqrczslb.vue?vue&type=script&lang=js&"
import style0 from "./jxqrczslb.vue?vue&type=style&index=0&id=7a2908a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2908a4",
  null
  
)

export default component.exports